import { IViewSettings } from "./ViewSettings"

export const SHOW_INACTIVE_LABELS_DEFAULT = false

export interface IViewSettingsLinkLabels {
    showInactiveLabels?: boolean
}

export default class ViewSettingsLinkLabels implements IViewSettings {
    showInactiveLabels: boolean = SHOW_INACTIVE_LABELS_DEFAULT

    constructor(data: IViewSettingsLinkLabels) {
        if (typeof data.showInactiveLabels !== "undefined") {
            this.showInactiveLabels = data.showInactiveLabels
        }
    }

    get isDefault() {
        return this.showInactiveLabels === SHOW_INACTIVE_LABELS_DEFAULT
    }
}
